import React from "react";
import styles from "./styles.module.css";

const Footer = () => (
  <div className={styles.footer}>ALL RIGHTS RESERVED ® 2020</div>
);

export default Footer;
